import { render } from "./UISplitButton.vue?vue&type=template&id=7ebf7c76&scoped=true"
import script from "./UISplitButton.vue?vue&type=script&lang=js"
export * from "./UISplitButton.vue?vue&type=script&lang=js"

import "./UISplitButton.vue?vue&type=style&index=0&id=7ebf7c76&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebf7c76"]])

export default __exports__